<template>
  <div class="relative px-8 py-20">
    <div v-if="orders" class="w-full bg-white flex flex-right  py-3" style="color: #414066">
      <h1 class="font-bold m-4" style="font-size: 1.5rem;">Orders</h1>
      <input
          type="text"
          class="admin-input"
          placeholder="Search"
          v-model="filter"
          style="width: 80%;"
        />
    </div>
    <div class="w-full h-full flex justify-center py-32 bg-white" >
      <button class="btn btn-light border-2 border-white" v-if="status === 'waiting'" @click="generateGrid()">Generate Grid</button>
      <div v-if="status === 'working'" class="w-full">
        <span class="w-full m-4" style="color: #414066;" >Generating new grid image. Please wait...</span>
        <div class="w-full flex justify-center">
          <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>    
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { toast } from 'vue3-toastify';
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';

const router = useRouter();
let status = ref('waiting');
const apiBase = process.env.VUE_APP_API_ADMIN_BASE;


onMounted(() => {
  if (!localStorage.getItem("token")) {
    router.push("/login");
  }
}); 

async function generateGrid() {
  status.value = 'working';

  try {
    const response = await axios.get(`${apiBase}/grid-reload`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });

    if(response.status === 200) {
      toast.success('New grid created.', { icon: false, });
    } else if(response.status != 200) {
      toast.success('There was a problem generating the grid.\nCheck grid and try again.', { icon: false, });
    }

  } catch (error) {
    const message = error.response?.data?.messages?.[0] || "Something went wrong!";
    toast.error(message, {
      icon: false,
    });
  } finally {
    status.value = 'waiting';
  }
}

</script>
